import { useParams } from 'react-router-dom';
import Description from 'src/components/description-block/description';
import PageHeader from 'src/components/page-header/page-header';
import { EVENTS } from 'src/constants/routes';
import { useGetEvent } from '../data/queries';
import css from './event-details.module.scss';
import EventInfo from './event-info';
import { ReactComponent as ExternalLinkIcon } from 'src/assets/external_link.svg';

export default function EventDetails() {
  const { slug } = useParams();
  const { data: event } = useGetEvent(slug);
  const page = {
    path: EVENTS.path,
    title: EVENTS.title
  };

  if (!event) {
    return null;
  }

  return (
    <main className={css.eventDetailsPage}>
      <PageHeader title={event.title} description={event.article?.title} pages={[page]} />
      <div className={css.body}>
        <div className={css.eventDetailsContainer}>
          <section className={css.eventDetails}>
            <h3 className={css.title}>{event.article?.title}</h3>
            <Description description={event.article?.description} />
          </section>
          <div className={css.infoBlock}>
            <section className={css.eventInfo}>
              <h3>Про подію</h3>
              <EventInfo event={event} showDate showRecurrenceName />

              {event.url && (
                <a href={event.url} target='_blank' rel='noopener noreferrer' className={css.linkButton}>
                  <span>Переглянути</span>
                  <ExternalLinkIcon />
                </a>
              )}
            </section>
          </div>
        </div>
      </div>
    </main>
  );
}
